module.exports = __webpack_public_path__ + "media/home3-right.aa8d061c.mp4";